
<template>
  <div class="d-flex w-100 justify-content-center">
    <div v-if="new_candidature">
      <h4 style="margin-top: 20px">
        {{ __("forms.sendApplication.updloadCV") }}
      </h4>
      <div v-if="files.length > 0">
        <div class="row">
          <div class="col-12" style="color: #00ff00; padding: 20px">
            <i class="fas fa-circle fa-2x"></i>
            <span style="color: black">{{ __("forms.sendApplication.fileReadyUpload") }}</span>
          </div>
          <div class="col-12" v-for="(file, index) in files" :key="index">
            <div class="row">
              <div class="col-1">
                <button href="#" type="button" @click="rmFileForm(file, index)">
                  <i class="fa fa-trash fa-2x"></i>
                </button>
              </div>
              <div class="col-7">
                {{ file.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div
            class="col-lg-1 col-md-1 col-12"
            style="color: #ff0000; padding: 20px"
          >
            <i class="fas fa-circle fa-2x"></i>
          </div>
          <div class="col-lg-2 col-md-2 col-12" style="padding: 20px">
            {{ __("forms.applicantCandidature.noFile") }}
          </div>
        </div>
      </div>

      <div
        style="width: 75%; height: 130px; position: relative"
        class="container-file-upload mx-auto"
        @drop="handleFileDrop"
        v-bind:style="{ 'background-color': color }"
      >
        <p>
          {{ __("forms.sendApplication.clickWhiteSpace") }}
          
        </p>
        <div class="file-wrapper">
          <input
            type="file"
            id="files"
            ref="files"
            multiple
            @change="handleFileInput"
          />
        </div>
      </div>
    </div>

    <div v-else>
      <a href="#" @click="openAttachments()">
        <i class="fas fa-file-alt" aria-hidden="true"></i>
        {{ __("views.People.Documents") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    module_name: {
      type: String,
      required: true,
    },
    new_candidature: {
      type: Boolean,
      required: true,
    },

    folder: {
      type: Number,
      required: false,
      default: null,
    },
    category: {
      type: String,
      required: false,
      default: null,
    },
    url_popup: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      files: [],
      color: "white",
    };
  },
  mounted() {
    console.log("CAT", this.category);
  },
  methods: {
    rmFileForm(index) {
      this.files.splice(index, 1);
    },
    openAttachments() {
      console.log(this.url_popup);
      app.__vue__.$refs.vue_popup.toggle("Allegati", this.url_popup);
    },

    cleanDuplicates() {
      console.log("OLD", this.files);
      var obj = {};

      for (var i = 0, len = this.files.length; i < len; i++)
        obj[this.files[i]["name"]] = this.files[i];

      let clean = new Array();
      for (var key in obj) clean.push(obj[key]);

      console.log("clean", clean);
      this.files = clean;
    },
    handleFileDrop(e) {
      let droppedFiles = e.dataTransfer.files;

      if (!droppedFiles) return;
      for (var i = 0, l = droppedFiles.length; i < l; i++) {
        this.files.push(droppedFiles[i]);
      }
      this.cleanDuplicates();
    },
    handleFileInput(e) {
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i]);
      }
      this.cleanDuplicates();
    },
    removeFile(fileKey) {
      this.files = [];
    },
    fileDragIn() {
      this.color = "white";
    },
  },
};
</script>

<style scoped>
.container-file-upload {
  border: 2px dashed red;
  height: 250px;
  padding: 15px;
}

.file-wrapper {
  text-align: center;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  display: table-cell;
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.file-wrapper input {
  cursor: pointer;
  opacity: 0;
  filter: alpha(
    opacity=0
  ); 

  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0;
}
</style>
